// Angular Files
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'plural'
})
export class PluralPipe implements PipeTransform {

    transform(value: any, wordToPlural?: any): any {
        return (value != 1 ? `${value} ${wordToPlural}s`: `${value} ${wordToPlural}`);
    }

}